import AIToolbarGroup from './AIToolbarGroup';
import CameraToolbarGroup from './CameraToolbarGroup';
import HistoryToolbarGroup from './HistoryToolbarGroup';
import SettingToolbarGroup from './SettingToolbarGroup';
import { default as DefaultToolbarGroup } from './ToolbarGroup';
import WorkingToolbarGroup from './WorkingToolbarGroup';

export const ToolbarGroup = Object.defineProperties(DefaultToolbarGroup, {
  AI: {
    get() {
      return AIToolbarGroup;
    },
  },
  Working: {
    get() {
      return WorkingToolbarGroup;
    },
  },
  History: {
    get() {
      return HistoryToolbarGroup;
    },
  },
  Camera: {
    get() {
      return CameraToolbarGroup;
    },
  },
  Setting: {
    get() {
      return SettingToolbarGroup;
    },
  },
}) as typeof DefaultToolbarGroup & {
  AI: typeof AIToolbarGroup;
  Working: typeof WorkingToolbarGroup;
  History: typeof HistoryToolbarGroup;
  Camera: typeof CameraToolbarGroup;
  Setting: typeof SettingToolbarGroup;
};
